import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../../assets/Icons";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import FormatAmount from "../../../../../components/_utils/FormatAmount/FormatAmount";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";

const TaxationMultiApprovalDeclined = () => {
  // 1️⃣ useNavigate
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // 2️⃣ useState
  const [declinedPageData, setdeclinedPageData] = useState([]);
  const [declinedPageID, setdeclinedPageID] = useState([]);

  // 3️⃣ Callback / Handler functions
  const buttonRows = [
    [
      {
        btnText: "Approve more transactions",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.APPROVE_MORE_TXN,
        imgColor: "var(--positive-bg)",
        handleFunction: () =>
          navigate("/tax_transaction_dashboard/tax_transaction_multi_select"),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () => navigate("/tax_transaction_dashboard"),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  const TransactionList = ({ transactions }) => (
    <div className="flex flex-col">
      {transactions?.map((account, i) => (
        <InfoCard
          key={account?.txn_id || i}
          bgColor="var(--positive-card)"
          hoverable="white"
          onClick={() =>
            navigate(
              `/tax_transaction_dashboard/tax_transaction_view_all/tax_transaction_detail_page/${account?.txn_id}`,
            )
          }
          rows={[
            {
              leftTitle: account?.tds_account_name,
              leftSubTitle: "Account name",
              hasRight: true,
              rightIcon: true,
              rightTitle: (
                <>
                  INR <FormatAmount price={account?.amount} />
                </>
              ),
              rightSubTitle: "Amount",
              rightTitleTextColor: "var(--text-primary)",
              rightTextFontWeight: "semibold",
              rightText: true,
              onClick: () =>
                navigate(
                  `/tax_transaction_dashboard/tax_transaction_view_all/tax_transaction_detail_page/${account?.txn_id}`,
                ),
            },
          ]}
        />
      ))}
    </div>
  );

  // 4️⃣ useEffect
  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedTaxData"),
    );

    if (storedSelectedApproval) {
      setdeclinedPageData(storedSelectedApproval?.selectedSendTransactions);
      setdeclinedPageID(storedSelectedApproval?.selectedTransactions);
    } else {
      setdeclinedPageData([]);
      setdeclinedPageID([]);
    }
  }, []);
  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);
  return (
    <>
      <StatusContainer
        status="success"
        buttonRows={buttonRows}
        title={declinedPageID?.length && "Transactions rejected successfully."}
      >
        <TabsWeapperSection
          title={`Rejected transactions  - ${
            declinedPageID?.length || declinedPageData?.length
          }`}
        >
          <TransactionList transactions={declinedPageData} />
        </TabsWeapperSection>
      </StatusContainer>
    </>
  );
};

export default TaxationMultiApprovalDeclined;
